import React from 'react'
import FormHelperText from '@material-ui/core/FormHelperText'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import './HelperTextOutside.less'
import { colors } from '../../../common/colors'

export const HelperTextOutside = (props) => {
    if (props?.helperText) {

        return (
            <FormHelperText
                id={`TextField-custom-${props?.key}`}
                error={props.error}
                className={`helperText ${props?.error && 'error'}`}
                style={{
                    marginTop:'4px',
                    fontSize: props?.size === 'small' ? '11px' : '13px',
                    lineHeight: props?.size === 'small' ? '15px' : '18px',
                    color: props?.error ? colors.error.default : colors.gray.gray06,
                }}
            >
                {props?.error && <ErrorOutlineIcon />}
                {props?.helperText}
            </FormHelperText>
        )
    }
    return null
}